import { useSelector } from 'react-redux'

import { FilterDropdown } from '@/components/search/FilterDropdown'
import { Checkbox } from '@/components/search/inputs/Checkbox'
import styles from '@/components/search/search.module.scss'
import { filterLabelPrettyName, filterClassName } from '@/lib/utilities/search'
import {
  selectActiveFeatures,
  selectFeaturesSearchFilter,
  selectFullActiveFeatures,
} from '@/store/selectors/search'
import { isProd } from '@/lib/utilities/system'

type FeaturesProps = {
  filter: string
  title: string
  supportingText?: {
    title: string
    subtitle?: string
  }
  toggleFilter: () => void
  isFilterOpen: boolean
  onChange: (params: { type: 'multi' | 'single'; filter: string; value: string | number }) => void
  typeName: string | undefined
}

type FeatureItem = {
  id: number
  name: string
  categoryId: number
}

export const Features = ({
  filter,
  title,
  supportingText,
  toggleFilter,
  isFilterOpen = false,
  onChange,
  typeName,
}: FeaturesProps) => {
  const availableFeatures = useSelector(selectFeaturesSearchFilter)
  const selectedFeatures = useSelector(selectActiveFeatures)
  const selectedFullFeatures = useSelector(selectFullActiveFeatures)

  const featureCategories = {
    cab: 1,
    flatbed: 2,
    sidePanels: 3,
  }


  const availableCategoryFeatures = availableFeatures
    .filter(
      (feature: FeatureItem) =>
        feature.categoryId === featureCategories[typeName as keyof object],
    )

  return (
    <FilterDropdown
      title={title}
      toggleFilter={toggleFilter}
      isFilterOpen={isFilterOpen}
      hasSelectedOptions={
        selectedFullFeatures.filter(
          (feature: FeatureItem) =>
            feature.categoryId === featureCategories[typeName as keyof object],
        ).length > 0
      }
      selectedOptions={
        selectedFullFeatures.filter(
          (feature: FeatureItem) =>
            feature.categoryId === featureCategories[typeName as keyof object],
        ).length > 0
          ? selectedFullFeatures
            .filter(
              (feature: FeatureItem) =>
                feature.categoryId === featureCategories[typeName as keyof object],
            )
            .map(i => filterLabelPrettyName(filter, i.name))
          : ['All']
      }>
      {availableCategoryFeatures.length > 0 ? (
        <>
          <div className={styles['multi-select']}>
            {availableCategoryFeatures
              .map((i: FeatureItem) => (
                <Checkbox
                  key={i.id}
                  valueAttribute="id"
                  item={i}
                  isSelected={selectedFeatures.includes(i.id)}
                  filter={filter}
                  onChange={onChange}
                  className={
                    !isProd()
                      ? `search__${filter}-${filterClassName(title)}-button search__${filter}-${filterClassName(title)}-button-${filterClassName(i.name)}`
                      : ''
                  }
                />
              ))}
          </div>
          {supportingText && (
            <div className={styles.supporting}>
              <p className={styles.title}>{supportingText.title}</p>
              {supportingText.subtitle && <p className={styles.subtitle}>{supportingText.subtitle}</p>}
            </div>
          )}
        </>
      ) : (
        <p className={styles['error-text']}>
          {`There are no "${title}" options available based on your current filter selections`}
        </p>
      )}
    </FilterDropdown>
  )
}
